import { Component, ElementRef, ViewChild } from '@angular/core';

import { FormFieldComponent } from '../form-field.types';

@Component({
  templateUrl: './textarea-form-field.component.html',
  styles: [
    `
      mat-form-field {
        textarea {
          opacity: 0.8;

          &:focus {
            opacity: 1;
          }
        }
      }
      .readonly {
        color: #717885 !important;
        opacity: 1 !important;
      }
      textarea.blurred {
        filter: blur(2px);
        font-style: italic;
        letter-spacing: 2px;
        text-wrap: nowrap;
      }
    `,
  ],
})
export class TextAreaFormFieldComponent extends FormFieldComponent {
  @ViewChild('inputControl') inputControl: ElementRef;

  public editing: boolean = false;
  public value: string;

  private _originalValue: string;
  private _readonly: boolean;

  ngOnInit(): void {
    super.ngOnInit();

    this.value = this.fieldDef.meta?.value_hidden && !this.editing ? 'REDACTED' : this.model[this.fieldDef.name];
    this._originalValue = this.value;

    if (this.fieldDef.meta && this.fieldDef.meta.readonly) {
      this._readonly = this.fieldDef.meta.readonly;
    }
    if (this.readonly) {
      this._readonly = this.readonly;
    }
    this.readonly = this._readonly;
  }

  edit(): void {
    if (!this.editing && !this._readonly) {
      this.editing = true;
      setTimeout(() => {
        this.inputControl.nativeElement.focus();
      }, 300);
    }
  }

  onBlur(): void {
    this.onSave();
    this.editing = false;
  }

  updateChangedModel(model: any): void {
    this.model = model;
    this.value = this.model[this.fieldDef.name];
    this._originalValue = this.value;
  }

  onSave(): void {
    if (this._originalValue != this.value) {
      this.updateModel();
      this.update.emit({ [this.fieldDef.name]: this.value });
    }
  }

  private updateModel(): void {
    this.model[this.fieldDef.name] = this.value;
    this._originalValue = this.value;
  }
}
